import { memo } from "react";
import "./whatsapp-share-button.scss";
import PropTypes from "prop-types";
import { WhatsappSvgrepoCom1Icon } from "app/icons/logo";

const WhatsAppShareButton = ({ text, label, onClick }) => {
	const onShare = () => onClick?.();

	return (
		<a
			className="whatsapps-share-button"
			data-testid="whatsapps-share-button"
			href={`whatsapp://send?text=${text}`}
			onClick={onShare}
		>
			<span className="whatsapps-share-button__icon">
				<WhatsappSvgrepoCom1Icon height={20} width={20} />
			</span>
			<span className="whatsapps-share-button__label">{label}</span>
		</a>
	);
};

WhatsAppShareButton.propTypes = {
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	onClick: PropTypes.func,
};

export default memo(WhatsAppShareButton);
